import * as React from "react";

import { WarningBanner } from "@graffer-inc/console-design-kit";
import { Loading } from "../../../../common/loading";
import { PaymentDetail } from "../../../payment/payment-detail/payment-detail";
import { matchType } from "../../../../../../application/domain/base/base-type";
import { CalcPaymentResult } from "./use-inspector-modal";
import { SmartApplyErrorCodeLiterals } from "@graffer-inc/smart-apply";

type PaymentSettingInspectorResultProps = {
  paymentResult: CalcPaymentResult;
};

export const PaymentSettingInspectorResult: React.FC<
  PaymentSettingInspectorResultProps
> = ({ paymentResult }) => {
  return (
    <div className="field">
      <label className="label">決済金額</label>
      {matchType(paymentResult.status, {
        Calculating: <Loading height="30px" width="30px" color="" />,
        Success: <PaymentDetail payment={paymentResult.payment!} />,
        Error: (
          <WarningBanner
            message="決済金額の計算結果が不正です"
            description={errorMsg(paymentResult.errorCode)}
          />
        ),
      })}
    </div>
  );
};

const errorMsg = (
  errorCode: SmartApplyErrorCodeLiterals | undefined | null,
): string => {
  if (errorCode === "bad_request.incalculable_formula") {
    return "金額の計算中にエラーが発生しました。計算結果がエラーにならないよう自動計算数式を修正してください。";
  } else if (errorCode === "bad_request.nan_payment_amount") {
    return "金額が「数値」以外の形式になりました。計算結果が「数値」になるように自動計算数式を修正してください。";
  } else if (errorCode === "bad_request.negative_payment_amount") {
    return "金額が0円より小さい値になりました。計算結果が0円以上になるように自動計算数式を修正してください。";
  } else if (errorCode === "bad_request.payment_amount_is_less_than_minimum") {
    return "金額の合計が2円未満になりました。金額の合計が2円以上になるように項目を入力するか、自動計算数式を修正してください。";
  }
  return "予期しないエラーが発生しました。管理者にお問い合わせください。";
};
